/**
 * Strips diacritical marks and lowercases a string so that searches are
 * accent-insensitive (e.g. "itau" matches "itaú").
 * Uses explicit Unicode ranges instead of \p{} property escapes for
 * broad browser/bundle compatibility.
 */
export const normalizeString = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // remove combining diacritic marks
    .replace(/[^a-zA-Z0-9\s-]+/g, '') // remove punctuation except hyphen/space
    .toLowerCase();
